module.exports = __webpack_public_path__ + "static/media/invoice_contract_help_efg_v2.dc86bcd1.png";